import { render, staticRenderFns } from "./WhenWillReceivePayment.vue?vue&type=template&id=5575e88c&scoped=true"
import script from "./WhenWillReceivePayment.vue?vue&type=script&lang=js"
export * from "./WhenWillReceivePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5575e88c",
  null
  
)

export default component.exports